module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-main page-border"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('p', {
    staticClass: "card-text"
  }), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 card-stat"
  }, [_c('loading-indicator')], 1)]), _vm._v(" "), _c('p')])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }],
    staticClass: "card"
  }, [_c('Client-usage-history', {
    attrs: {
      "team": _vm.team,
      "showTitle": false
    },
    on: {
      "loadChanged": _vm.clientUsageHistoryLoadChanged
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_vm._v("Admin")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Client Usage History")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-18269877!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/billings/ManageClientUsageHistory.vue
// module id = 507
// module chunks = 1